import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/main.css'
import './css/common.css'
import './css/payment.css'
import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, TotalAmountCount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import html2canvas from 'html2canvas';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchDateMonth, SearchDateMobile } from './component/search/search';
import dayjs from 'dayjs';
import { formatDateTime, changeNum } from './common/function';

import useWindowSize from './hook/useWindowSize'

function Paylist() {
    let navigate = useNavigate();
    let dispatch = useDispatch()

    const { Rwidth, Rheight } = useWindowSize();

    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [amount, setAmount] = useState([1000000, 50000])
    const [modal1, setModal1] = useState(false)

    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clickData, setClickData] = useState([])
    const [reload, setReload] = useState(false)


    useEffect(() => {
        dispatch(change_Current_Location("거래조회"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: ""
        }))
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChangeMaxPage = (event) => {
        setMaxFirstPage(Number(event.target.value));
    };

    // 기간 포맷
    const inputRef = useRef(null);   // 숨겨진(또는 실제) datepicker input
    const pickerRef = useRef(null);  // Litepicker instance

    // 날짜 상태 (초기값: 이번 달)
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY/MM/DD'));
    const [nextDate, setNextDate] = useState(dayjs().endOf('month').format('YYYY/MM/DD'));

    // ★ 핵심: inputRef.current(또는 화면폭) 바뀔 때마다 재부착
    useEffect(() => {
        const el = inputRef.current;
        if (!el) return;

        // 기존 인스턴스 정리
        if (pickerRef.current) {
            pickerRef.current.destroy();
            pickerRef.current = null;
        }

        // 새 인스턴스 부착
        const picker = new Litepicker({
            element: el,
            lang: "ko",
            singleMode: false,
            format: "YYYY/MM/DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: { minYear: 2020, maxYear: 2030, months: true, years: true },
            setup: (p) => {
                p.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY/MM/DD"));
                    setNextDate(end.format("YYYY/MM/DD"));
                });
            },
        });

        pickerRef.current = picker;

        // 현재 선택 범위 반영
        picker.setDateRange(preDate, nextDate);

        // cleanup
        return () => {
            picker.destroy();
            pickerRef.current = null;
        };
        // 화면 레이아웃 전환시에도 재초기화를 원하면 Rwidth 같은 뷰포트 상태도 deps에 포함
    }, [inputRef.current /*, Rwidth */]);

    // 날짜 상태가 바뀌면 picker에도 반영 (인스턴스가 살아있을 때만)
    useEffect(() => {
        pickerRef.current?.setDateRange(preDate, nextDate);
    }, [preDate, nextDate]);

    // 공용 setter
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        setPage(1);
    };

    useEffect(() => {
        ListData()
    }, [page, preDate, nextDate, maxFirstPage])

    const ListData = async () => {
        if (page == 1) setLoading(true)
        await axios.get(process.env.REACT_APP_API + "/api/sugi", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                if (page === 1) {
                    setListData(tmp?.data?.sugi ?? []);
                }
                else {
                    setListData((prev) => [...prev, ...tmp?.data?.sugi ?? []]);
                }
                setAmount([Number(tmp?.data?.summary?.total_amount), Number(tmp?.data?.summary?.cancel_amount)])
                setTotalPage(tmp?.data?.pagination?.total ?? 0)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setLoading(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 13, "text": "전표", "width": "40px", "textAlign": "center" },
        { "no": 2, "text": "거래일", "width": "100px", "textAlign": "center" },
        { "no": 4, "text": "거래금액", "width": "85px", "textAlign": "center" },
        { "no": 8, "text": "카드번호", "width": "110px", "textAlign": "center" },
        // { "no": 1, "text": "NO", "width": "50px", "textAlign": "center" },
        // { "no": 3, "text": "취소일", "width": "100px", "textAlign": "center" },
        // { "no": 14, "text": "거래상태", "width": "70px", "textAlign": "center" },
        // { "no": 5, "text": "잔여금액", "width": "100px", "textAlign": "center" },
        // { "no": 6, "text": "할부", "width": "100px", "textAlign": "center" },
        // { "no": 7, "text": "결제서비스", "width": "100px", "textAlign": "center" },
        // { "no": 9, "text": "구매자명", "width": "100px", "textAlign": "center" },
        // { "no": 10, "text": "상품명", "width": "100px", "textAlign": "center" },
        // { "no": 11, "text": "주문번호", "width": "200px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData ?? []

            let pre = preDate.replace(/\//g, '')
            let next = nextDate.replace(/\//g, '')

            for (let i = 0; i < list.length; i++) {
                let data = list[i];
                let trxDateOnly = data.trx_date?.slice(0, 10).replace(/-/g, '');

                if (Number(pre) <= Number(trxDateOnly) && Number(trxDateOnly) <= Number(next)) {
                    tableBodyData.push([
                        {
                            "no": 13,
                            "text": (
                                <div className='pointer list-text-center' onClick={() => { setClickData(data); setModal1(true) }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-clipboard w-4 h-4" style={{ color: "#0a6e0a" }}>
                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                    </svg>
                                </div>
                            ),
                            "width": "40px",
                            "textAlign": "center"
                        },
                        { "no": 2, "text": formatDateTime(data.trx_date), "width": "100px", "textAlign": "center" },
                        { "no": 4, "text": changeNum(Number(data.amt)), "width": "85px", "textAlign": "right" },
                        { "no": 8, "text": data.card_num, "width": "110px", "textAlign": "center" },
                        // { "no": 1, "text": data.id, "width": "50px", "textAlign": "center" },
                        // { "no": 3, "text": data.cancel_date ? formatDateTime(data.cancel_date) : '', "width": "100px", "textAlign": "center" },
                        // { "no": 14, "text": data.state === "1" ? "승인" : data.state === "2" ? "매입 전 취소" : data.state === "3" ? "매입 후 취소" : "-", "width": "70px", "textAlign": 'center' },
                        // { "no": 5, "text": `${(Number(data.amt) + Number(data.remain_amt)).toLocaleString()}원`, "width": "100px", "textAlign": "right" },
                        // { "no": 6, "text": data.quota === "00" ? "일시불" : `${data.quota}개월`, "width": "100px", "textAlign": "center" },
                        // { "no": 7, "text": data.payment_service, "width": "100px", "textAlign": 'center' },
                        // { "no": 9, "text": data?.buyer_nm ?? "", "width": "100px", "textAlign": "center" },
                        // { "no": 10, "text": data.prd_nm, "width": "100px", "textAlign": "center" },
                        // { "no": 11, "text": data.order_id, "width": "200px", "textAlign": "center" },                        
                    ])
                }
            }

            setCombineData(tableBodyData)
        }
    }, [listData, reload]);

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/sugi", {
            withCredentials: true,
            params: {

            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.sugi ?? [])
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            console.log(exData);
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                try {
                    arr.push({
                        "NO": i + 1,
                        "MID": t.mid,
                        "거래일시": t.trx_date,
                        "취소일시": t.cancel_date,
                        "거래상태": t.state == '1' ? "승인" : t.status == '2' ? "매입전취소" : "매입후취소",
                        "거래금액": `${Number(t.amt).toLocaleString()}원`,
                        "결제서비스": t.payment_service,
                        "결제구분": t.payment_type,
                        "구매자명": t.buyer_nm,
                        "카드": t.card,
                        "할부": t.quota === "00" ? "일시불" : `${t.quota}개월`,
                        "상품명": t.prd_nm,
                        "주문번호": t.order_id,
                        "거래번호": t.trx_id,
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel(arr)
    }


    const isMobile = Rwidth <= 767;

    // 스크롤 컨테이너(모바일 영역) 참조
    const mobileScrollRef = useRef(null);

    // observer 인스턴스 보관
    const ioRef = useRef(null);

    // sentinel을 바꿀 때마다 자동으로 observe/cleanup 되는 콜백 ref
    const setSentinelRef = useCallback((node) => {
        // 이전 관찰 중단
        if (ioRef.current) {
            ioRef.current.disconnect();
            ioRef.current = null;
        }
        if (!node) return;

        // root: 모바일은 내부 스크롤 박스, 데스크톱은 기본(뷰포트 또는 외부 스크롤러)
        const rootEl = isMobile ? mobileScrollRef.current : null;

        ioRef.current = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalPage >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        }, {
            root: rootEl,            // 중요: 모바일에서 내부 스크롤 컨테이너 지정
            rootMargin: "200px 0px", // 여유롭게 미리 로드
            threshold: 0
        });

        ioRef.current.observe(node);
    }, [isMobile, totalPage, page, maxFirstPage]);

    // list 변경·레이아웃 전환 시에도 sentinel 재연결 보장 (콜백 ref가 처리하지만 안전망)
    useEffect(() => {
        return () => { ioRef.current?.disconnect(); };
    }, []);

    const sortedList = useMemo(
        () => [...listData].sort((a, b) => dayjs(b.trx_date) - dayjs(a.trx_date)),
        [listData]
    );

    let lastKey = null;

    const dateKey = (s) => dayjs(s).format("YY.MM.DD"); // 예: 25.08.01
    const timeStr = (s) => dayjs(s).format("HH:mm");    // 예: 12:45

    return (
        <>
            {loading ? <LoadingModal /> : ""}
            {modal1 ? <ReceiptInfo setModal={setModal1} clickData={clickData} /> : ""}
            {
                Rwidth > 767
                    ?
                    <div class="content" id="contents">
                        <div class="paylist">
                            <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
                                <div class="form_filter w-full">
                                    <SearchDate
                                        type={"날짜"}
                                        inputRef={inputRef}
                                        setDateRange={setDateRange}
                                        preDate={preDate}
                                        nextDate={nextDate}
                                    />
                                </div>
                            </form>
                            <div className="intro-y box p-5 mt-2">
                                {/* <div className="tabulator_sorting_wrap">
                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                        <CountSelect onChange={handleChangeMaxPage} maxFirstPage={maxFirstPage} />
                    </div> */}
                                <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end' }}>
                                    {/* <TotalAmountCount
                            confirm_amt={Number(listData?.stateSummary?.find(item => item.state == '1')?.total_amt ?? 0)}
                            confirm_cnt={Number(listData?.stateSummary?.find(item => item.state == '1')?.count ?? 0)}
                            canceled_amt={Number(listData?.stateSummary?.find(item => item.state == '2')?.total_amt ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '3')?.total_amt ?? 0)}
                            canceled_cnt={Number(listData?.stateSummary?.find(item => item.state == '2')?.count ?? 0) + Number(listData?.stateSummary?.find(item => item.state == '3')?.count ?? 0)}
                        /> */}

                                    <TotalAmount confirm_amt={amount[0]} canceled_amt={Number(amount[1]) * -1} />
                                    <CountAmount tableBodyData={totalPage ?? 0} />
                                </div>
                                <div style={{ maxWidth: "400px", width: "100%" }}>
                                    <List
                                        tableHeaderData={tableHeaderData}
                                        tableBodyData={totalPage ?? 0}
                                        filter_tableBodyData={combineData}
                                        page={page}
                                        setPage={setPage}
                                        maxFirstPage={maxFirstPage}
                                        observerRef={setSentinelRef}
                                        nonePage={false}
                                        scrollState={true}
                                        height={"800px"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div style={{ marginTop: "3.5rem", background: "#fff", minHeight: "calc(100dvh - 3.5rem)" }}>
                        <div style={{ padding: "20px 15px", borderBottom: "6px solid #f1f1f1" }}>
                            <SearchDateMobile
                                type={"날짜"}
                                inputRef={inputRef}
                                setDateRange={setDateRange}
                                preDate={preDate}
                                nextDate={nextDate}
                            />
                        </div>
                        <div style={{ padding: "15px 15px 10px", borderBottom: "6px solid #f1f1f1" }}>
                            <div style={{ fontSize: "13px", color: "#a9a9ab", fontWeight: "500", marginBottom: "3px" }}>{`${preDate}~${nextDate}`}</div>
                            <div style={{ padding: "20px 12px", background: "#f5f6f8", borderRadius: "8px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div>매출 합계</div>
                                    <div>
                                        <span>{changeNum(Number(amount[0]) + Number(amount[1]) * -1)}</span>
                                        <span style={{ marginLeft: "2px" }}>원</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "0px", borderBottom: "6px solid #f1f1f1", height: "calc(100dvh - 310px)", overflow: "scroll" }}>
                            {sortedList.map((item, i) => {
                                const dKey = dateKey(item.trx_date);
                                const tStr = timeStr(item.trx_date);
                                const showHeader = dKey !== lastKey;
                                lastKey = dKey;

                                return (
                                    <Fragment key={item.trx_id ?? i}>
                                        {showHeader &&
                                            <div
                                                style={{
                                                    background: "#f1f1f1",
                                                    textAlign: "center",
                                                    padding: "4px",
                                                    fontWeight: "500"
                                                }}
                                            >{dKey}</div>}

                                        {/* 시간만 왼쪽에 찍고 싶다면 timeStr을 prop으로 넘기세요 */}
                                        <MobileListItem
                                            item={item}
                                            setClickData={setClickData}
                                            setModal1={setModal1}
                                        />
                                    </Fragment>
                                );
                            })}
                            <div ref={setSentinelRef} style={{ height: '1px' }}></div>
                        </div>
                    </div>
            }
        </>
    )
}

function MobileListItem({ item, setClickData, setModal1 }) {
    const raw = item.trx_date; // "2025-08-01 12:45:15"
    const [datePart, timePart] = raw.split(" ");   // ["2025-08-01", "12:45:15"]

    // 날짜: 2025-08-01 → 25.08.01
    const dateStr = datePart.slice(2).replace(/-/g, "."); // "25.08.01"

    // 시간: 12:45:15 → 12:45
    const timeStr = timePart.slice(0, 5);

    return (
        <div style={{
            display: "flex",
            gap: "15px",
            borderBottom: "1px solid #f1f1f1",
            padding: "15px",
            position: "relative"
        }}>
            <div style={{ fontSize: "13px", color: "#82898f", textAlign: "right" }}>
                <div style={{ height: "15px" }}>{timeStr}</div>
            </div>
            <div style={{ width: "100%" }}>
                <div style={{ fontSize: "13px", fontWeight: "500", display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                    <div>빠른결제_가맹 [{item.payment_type}]</div>
                    <div style={{ fontSize: "14px", fontWeight: "600" }}>{changeNum(Number(item.amt))}원</div>
                </div>
                {/* <div style={{ fontSize: "13px", fontWeight: "500" }}>빠른결제_가맹 [{item.payment_type}]</div> */}
                {/* <div style={{ fontSize: "13px", fontWeight: "500", marginBottom: "2px" }}>{changeNum(Number(item.amt))}원</div> */}
                <div style={{ fontSize: "10px", color: "#82898f", height: "15px" }}>{item.order_id}</div>
                <div style={{ fontSize: "10px", color: "#82898f", height: "15px" }}>
                    {/* {dateStr}
                    <span style={{ margin: "0 5px", fontWeight: "600", fontSize: "13px", color: "#000" }}>|</span> */}
                    {item.card}
                    <span style={{ margin: "0 5px", fontWeight: "600", fontSize: "13px", color: "#000" }}>|</span>
                    {item.quota == "00" ? "일시불" : `${item.quota}개월`}
                    <span style={{ margin: "0 5px", fontWeight: "600", fontSize: "13px", color: "#000" }}>|</span>
                    {item.approval_id}
                </div>
            </div>
            <div
                className='mobile-date-btn'
                style={{ position: "absolute", bottom: "13px", right: "15px", padding: "3px 5px", border: "1px solid #e5e8eb", borderRadius: "4px", fontSize: "10px", color: "#82898f", cursor: "pointer", fontWeight: "500" }}
                onClick={() => { setClickData(item); setModal1(true) }}>
                상세 거래내역
            </div>
        </div>
    )
}

function ReceiptInfo({ setModal, clickData }) {
    const { Rwidth, Rheight } = useWindowSize();
    const divRef = useRef(null);

    const handleCapture = async () => {
        if (!divRef.current) return;

        const canvas = await html2canvas(divRef.current);

        // ✅ 이미지 저장
        const link = document.createElement('a');
        link.download = 'capture.png';
        link.href = canvas.toDataURL();
        link.click();

        // ✅ 클립보드 복사
        canvas.toBlob(async (blob) => {
            try {
                await navigator.clipboard.write([
                    new ClipboardItem({
                        [blob.type]: blob,
                    }),
                ]);
                alert('이미지가 클립보드에 복사되었고, 저장도 완료되었습니다!');
            } catch (err) {
                console.error('클립보드 복사 실패:', err);
                alert('이미지 저장은 성공했지만, 클립보드 복사는 실패했어요 😢');
            }
        });
    };
    return (
        <div id="receipt-modal" className="modal" tabindex="-1" >
            <div className="modal-dialog" style={{ padding: Rwidth > 767 ? "2rem" : "1rem .75rem" }}>
                <div className="modal-content marginTop30 modal_sty type-receipt receipt-modal-content">
                    <div className="modal-header receipt-modal-header" style={{ border: "none" }}>
                        <h2 className="font-medium text-base mr-auto modal_title_sty">결제 정보</h2>
                        <button className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4" data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <form id="modal-form" ref={divRef}>
                        <div className="modal-body receipt-modal-body">
                            <div className="box-sales" id="box-sales" style={{ padding: "1rem 0" }}>
                                {
                                    // 취소시 취소 이미지
                                    clickData?.cancelType
                                        ?
                                        <div className="box-result" style={{ top: "50%", position: "absolute" }}>
                                            <div className="inner">
                                                <img src="/img/bg_cancel.png" alt="취소" />
                                            </div>
                                        </div>
                                        :
                                        ""
                                }
                                <div id="header">
                                    <h1><img src="/img/win_logo_top.png" style={{ height: "20px" }} alt="앤트페이" /></h1>
                                    <h2 style={{ fontSize: ".9rem", fontWeight: "bold" }}>신용카드 매출전표</h2>
                                </div>
                                <div className="list-info-box">
                                    <div className="box-gap">
                                        <div className="gap">
                                            <div className="tt"><h3>결제정보</h3></div>
                                            <ul>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text">결제수단</span>
                                                        <span className="right-text" data-id="CARD_NO">{clickData.payment_service}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text">거래상태</span>
                                                        <span className="right-text" data-id="CARD_NAME">{clickData.state == 1 ? "승인" : "취소"}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text">거래일시</span>
                                                        <span className="right-text" data-id="CARD_NO">{clickData.trx_date}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text">취소일시</span>
                                                        <span className="right-text" data-id="CARD_NAME">{clickData.cancel_date}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text">결제카드</span>
                                                        <span className="right-text" data-id="CARD_NO">{clickData.card}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text">카드번호</span>
                                                        <span className="right-text" data-id="CARD_NAME">{clickData.card_num}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text">할부개월</span>
                                                        <span className="right-text" data-id="CARD_NO">{clickData.quota == "00" ? "일시불" : `${clickData.quota}개월`}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text">{clickData?.cancel_approval_id ? "취소번호" : "승인번호"}</span>
                                                        <span className="right-text" data-id="CARD_NAME">{clickData?.cancel_approval_id ? clickData?.cancel_approval_id : clickData.approval_id}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text">{clickData?.cancel_approval_id ? "취소금액" : "승인금액"}</span>
                                                        <span className="right-text" data-id="CARD_NO">{changeNum(Number(clickData.total_amt))}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text">과세금액</span>
                                                        <span className="right-text" data-id="CARD_NAME">
                                                            {clickData?.cancel_approval_id ? 0 : changeNum(Math.floor(Number(clickData.total_amt)) - Math.floor(Number(clickData.total_amt) * 0.1 / 1.1))}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text">구매자명</span>
                                                        <span className="right-text" data-id="CARD_NO">{clickData.buyer_nm}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text">부가세</span>
                                                        <span className="right-text" data-id="CARD_NAME">
                                                            {clickData?.cancel_approval_id ? 0 : changeNum(Math.floor(Number(clickData.total_amt) * 0.1 / 1.1))}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="inner">
                                                        <span className="left-text">상품명</span>
                                                        <span className="right-text" data-id="CARD_NO">{clickData.prd_nm}</span>
                                                    </div>
                                                    <div className="inner">
                                                        <span className="left-text">면세금액</span>
                                                        <span className="right-text" data-id="CARD_NAME">{0}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="infoFooter">
                                    ＊ 부가세법 제46조에 따라 신용카드 매출전표를 이용하여 매입세액 공제가 가능합니다.(동법 제 33조 2항에 근거하여 신용카드 매출전표를 발행한 경우에는 세금계산서를 발급하지 아니합니다.)
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="modal-footer" style={{ border: "none" }}>
                        <button id="receipt_print_btn" type="button" className="btn"
                            style={{ marginRight: "3px", backgroundColor: "#d2e4fb", fontWeight: "600" }}
                            onClick={handleCapture}
                        >저장</button>
                        <button type="button" className="btn w-20 modal_btn receipt_close_btn" onClick={() => setModal(false)}>닫기</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `거래내역`;

    const ws = XLSX.utils.aoa_to_sheet([
        [
            "NO", "MID", "거래일시", "취소일시", "거래상태", "거래금액", "결제서비스", "결제구분", "구매자명", "카드", "할부", "상품명", "주문번호", "거래번호"
        ]
    ]);
    excelData.map((data) => {
        XLSX.utils.sheet_add_aoa(
            ws,
            [
                [
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.NO },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.MID },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.취소일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래상태 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래금액 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제서비스 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제구분 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.구매자명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.카드 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.할부 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.상품명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.주문번호 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래번호 }
                ]
            ],
            { origin: -1 }
        );
        ws['!cols'] = [
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 }
        ]
        return false;
    });
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelButter], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default Paylist;